import printReportAction from '@/components/nsw-components/PrintReportsAction';
import DocumentNewVersionAction from '@/components/nsw-components/DocumentNewVersionAction';

export default {
	actions: [
		printReportAction.printReport('CREW_LIST', 'imofalformid', 'reports.label.falForms.crewList'),
		DocumentNewVersionAction.newVersion({
			imofalformtypeid: 5
		})
	]
};
